import { render } from "./CoursesList.vue?vue&type=template&id=5fbe89e6"
import script from "./CoursesList.vue?vue&type=script&lang=js"
export * from "./CoursesList.vue?vue&type=script&lang=js"

import exportComponent from "/Users/gabrielalencar/Documents/custom/gestio-school-frontend-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__